export const CURRENCIES = {
    EUR: "Euro (€)",
    USD: "Dollar US ($)",
    GBP: "Livre sterling (£)",
    CHF: "Franc suisse (CHF)",
    CAD: "Dollar canadien (CAD)",
    JPY: "Yen (¥)",
};

export const getCurrencySymbol = (code) => {
    const symbols = { EUR: "€", USD: "$", GBP: "£", CHF: "CHF", CAD: "CAD", JPY: "¥" };
    return symbols[code] || code;
};
